<template>
  <div class="content">
    <div class="md-layout">
      <div
          v-if="statistics && weeklyChart?.data?.labels.length"
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
       <chart-card
           :chart-data="weeklyChart?.data"
           :chart-options="weeklyChart?.options"
           :chart-type="'Bar'"
           data-background-color="blue"
       >
         <template slot="content">
           <h4 class="title">Weekly bookings</h4>
           <p class="category">
             Last Week Performance
           </p>
         </template>

         <template slot="footer">
           <div class="stats">
             <md-icon>access_time</md-icon>
             updated 4 minutes ago
           </div>
          </template>
       </chart-card>
      </div>
<!--      <div-->
<!--          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"-->
<!--      >-->
<!--        <chart-card-->
<!--            :chart-data="emailsSubscriptionChart.data"-->
<!--            :chart-options="emailsSubscriptionChart.options"-->
<!--            :chart-responsive-options="emailsSubscriptionChart.responsiveOptions"-->
<!--            :chart-type="'Bar'"-->
<!--            data-background-color="red"-->
<!--        >-->
<!--          <template slot="content">-->
<!--            <h4 class="title">Email Subscription</h4>-->
<!--            <p class="category">Last Campaign Performance</p>-->
<!--          </template>-->

<!--          <template slot="footer">-->
<!--            <div class="stats">-->
<!--              <md-icon>access_time</md-icon>-->
<!--              updated 10 days ago-->
<!--            </div>-->
<!--          </template>-->
<!--        </chart-card>-->
<!--      </div>-->



      <div
          v-if="statistics && monthlyChart?.data?.labels.length"
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
      >
        <chart-card
            :chart-data="monthlyChart.data"
            :chart-options="monthlyChart.options"
            :chart-type="'Bar'"
            data-background-color="green"
        >
          <template slot="content">
            <h4 class="title">Monthly Bookings</h4>
            <p class="category">Last Month Performance</p>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>access_time</md-icon>
              updated 4 minutes ago
            </div>
          </template>
        </chart-card>
      </div>



      <div
          v-if="statistics"
          class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>store</md-icon>
          </template>

          <template slot="content">
            <p class="category">Available Listings</p>
            <h3 class="title">{{statistics.available_listings}}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              Just Updated
            </div>
          </template>
        </stats-card>
      </div>
      <div
          v-if="statistics"
          class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>bed</md-icon>
          </template>

          <template slot="content">
            <p class="category">Total Bookings</p>
            <h3 class="title">
             {{statistics.total_bookings}}
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              Just Updated
            </div>
          </template>
        </stats-card>
      </div>
<!--      <div-->
<!--          class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"-->
<!--      >-->
<!--        <stats-card data-background-color="red">-->
<!--          <template slot="header">-->
<!--            <md-icon>info_outline</md-icon>-->
<!--          </template>-->

<!--          <template slot="content">-->
<!--            <p class="category">Fixed Issues</p>-->
<!--            <h3 class="title">75</h3>-->
<!--          </template>-->

<!--          <template slot="footer">-->
<!--            <div class="stats">-->
<!--              <md-icon>update</md-icon>-->
<!--              Just Updated-->
<!--            </div>-->
<!--          </template>-->
<!--        </stats-card>-->
<!--      </div>-->
      <div
          v-if="statistics"
          class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
      >
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>apartment</md-icon>
          </template>

          <template slot="content">
            <p class="category">Total Listings</p>
            <h3 class="title">{{statistics.total_listings}}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>update</md-icon>
              Just Updated
            </div>
          </template>
        </stats-card>
      </div>
<!--      <div-->
<!--          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"-->
<!--      >-->
<!--        <md-card>-->
<!--          <md-card-header data-background-color="orange">-->
<!--            <h4 class="title">Employees Stats</h4>-->
<!--            <p class="category">New employees on 15th September, 2016</p>-->
<!--          </md-card-header>-->
<!--          <md-card-content>-->
<!--            <ordered-table table-header-color="orange"></ordered-table>-->
<!--          </md-card-content>-->
<!--        </md-card>-->
<!--      </div>-->
<!--      <div-->
<!--          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"-->
<!--      >-->
<!--        <nav-tabs-card>-->
<!--          <template slot="content">-->
<!--            <span class="md-nav-tabs-title">Tasks:</span>-->
<!--            <md-tabs class="md-success" md-alignment="left">-->
<!--              <md-tab id="tab-home" md-label="Bugs" md-icon="bug_report">-->
<!--                <nav-tabs-table></nav-tabs-table>-->
<!--              </md-tab>-->

<!--              <md-tab id="tab-pages" md-label="Website" md-icon="code">-->
<!--                <nav-tabs-table></nav-tabs-table>-->
<!--              </md-tab>-->

<!--              <md-tab id="tab-posts" md-label="server" md-icon="cloud">-->
<!--                <nav-tabs-table></nav-tabs-table>-->
<!--              </md-tab>-->
<!--            </md-tabs>-->
<!--          </template>-->
<!--        </nav-tabs-card>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import Chartist from 'chartist';
import 'chartist-plugin-legend';
import 'chartist-plugin-tooltips';
import {
  StatsCard,
  ChartCard,
  NavTabsCard,
  NavTabsTable,
  OrderedTable,
} from "@/components";
import {mapActions} from "vuex";

export default {
  components: {
    StatsCard,
    ChartCard,
    NavTabsCard,
    NavTabsTable,
    OrderedTable,
  },
  data() {
    return {
      statistics: null,
      weeklyChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: Chartist.Interpolation.simple(),
          showArea: true,
          fullWidth: true,
          low: 0,
          high: 10,
          chartPadding: { right: 10, left: 10 },
          axisX: {
            labelInterpolationFnc: (value) => value.split(" ")[0], // show just "2025-11"
          },
          axisY: {
            onlyInteger: true,
            labelInterpolationFnc: (value) => (value % 1 === 0 ? value : null),
          },
          plugins: [
            Chartist.plugins.legend({
              legendNames: [' Bookings per Week'],
              classNames: ['weekly-line']
            }),
            // Chartist.plugins.tooltip()
          ]
        },
      },
      monthlyChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          lineSmooth: Chartist.Interpolation.simple(),
          showArea: true,
          fullWidth: true,
          low: 0,
          high: 10,
          chartPadding: { right: 10, left: 10 },
          axisX: {
            labelInterpolationFnc: (value) => value.split(" ")[0], // show just "2025-11"
          },
          axisY: {
            onlyInteger: true,
            labelInterpolationFnc: (value) => (value % 1 === 0 ? value : null),
          },
          plugins: [
            Chartist.plugins.legend({
              legendNames: ['Bookings per Month'],
              classNames: ['monthly-line']
            }),
            // Chartist.plugins.tooltip()
          ]
        },
      },
      // emailsSubscriptionChart: {
      //   data: {
      //     labels: [
      //       "Ja",
      //       "Fe",
      //       "Ma",
      //       "Ap",
      //       "Mai",
      //       "Ju",
      //       "Jul",
      //       "Au",
      //       "Se",
      //       "Oc",
      //       "No",
      //       "De",
      //     ],
      //     series: [
      //       [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
      //     ],
      //   },
      //   options: {
      //     axisX: {
      //       showGrid: false,
      //     },
      //     low: 0,
      //     high: 1000,
      //     chartPadding: {
      //       top: 0,
      //       right: 5,
      //       bottom: 0,
      //       left: 0,
      //     },
      //   },
      //   responsiveOptions: [
      //     [
      //       "screen and (max-width: 640px)",
      //       {
      //         seriesBarDistance: 5,
      //         axisX: {
      //           labelInterpolationFnc: function (value) {
      //             return value[0];
      //           },
      //         },
      //       },
      //     ],
      //   ],
      // },
    };
  },
  created() {
    this.getDashData()
  },
  methods: {
    ...mapActions(['getDashboardData']),
    getDashData() {
      this.getDashboardData()
          .then((res) => {
            const stats = res?.data || {};
            this.statistics = stats;

            // Safely extract bookings data
            const weekly = stats.weekly_bookings || { labels: [], data: [] };
            const monthly = stats.monthly_bookings || { labels: [], data: [] };

            // Compute max safely with proper fallback
            const getChartMax = (dataArray) => {
              if (!dataArray || dataArray.length === 0) return 10;
              const max = Math.max(...dataArray, 0);
              // If all values are 0 or negative, return default
              return max > 0 ? max : 10;
            };

            const weeklyMax = getChartMax(weekly.data);
            const monthlyMax = getChartMax(monthly.data);

            // Assign chart data safely
            this.weeklyChart.data = {
              labels: weekly.labels,
              series: [weekly.data],
            };
            this.weeklyChart.options = {
              ...this.weeklyChart.options,
              low: 0,
              high: Math.ceil(weeklyMax + weeklyMax * 0.2),
            };

            this.monthlyChart.data = {
              labels: monthly.labels,
              series: [monthly.data],
            };
            this.monthlyChart.options = {
              ...this.monthlyChart.options,
              low: 0,
              high: Math.ceil(monthlyMax + monthlyMax * 0.2),
            };
          })
          .catch((err) => {
            console.error('Dashboard data fetch failed:', err);
          });
      // .then((res) => {
        // this.statistics = res.data
        // this.weeklyChart.data.labels = res.data.weekly_bookings.labels
        // this.weeklyChart.data.series = [res.data.weekly_bookings.data]
        // this.monthlyChart.data.labels = res.data.monthly_bookings.labels
        // this.monthlyChart.data.series = [res.data.monthly_bookings.data]

        // const weeklyMax = Math.max(...res.data.weekly_bookings.data, 10);
        // const monthlyMax = Math.max(...res.data.monthly_bookings.data, 10);
        //
        // this.weeklyChart.data.labels = res.data.weekly_bookings.labels;
        // this.weeklyChart.data.series = [res.data.weekly_bookings.data];
        // this.weeklyChart.options.high = weeklyMax + weeklyMax * 0.2;
        //
        // this.monthlyChart.data.labels = res.data.monthly_bookings.labels;
        // this.monthlyChart.data.series = [res.data.monthly_bookings.data];
        // this.monthlyChart.options.high = monthlyMax + monthlyMax * 0.2;
      // })

    }
  }
};
</script>
<style scoped>
.ct-series-a .ct-line {
  stroke: #42a5f5;
  stroke-width: 3px;
}
.ct-series-a .ct-point {
  stroke: #1e88e5;
  stroke-width: 8px;
}
.ct-series-a .ct-area {
  fill: rgba(66, 165, 245, 0.15);
}
::v-deep .ct-label {
  font-size: 14px;
}
/* Legend styles */
.ct-legend {
  position: relative;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 14px;
}
.ct-legend li {
  position: relative;
  padding-left: 20px;
  cursor: default;
}
.ct-legend li::before {
  width: 12px;
  height: 12px;
  position: absolute;
  left: 0;
  top: 4px;
  content: "";
  border-radius: 3px;
}
.ct-legend .weekly-line::before {
  background: #42a5f5;
}
::v-deep .ct-legend .weekly-line,
::v-deep .ct-legend .monthly-line {
  padding-top: 5px;
  padding-left: 5px;
}
.ct-legend .monthly-line::before {
  background: #66bb6a;
}
.ct-tooltip {
  background: rgba(50, 50, 50, 0.8);
  color: #fff;
  border-radius: 4px;
  padding: 6px 8px;
  font-size: 13px;
  text-align: center;
}


/* Center both X and Y axis labels */
::v-deep .ct-label.ct-horizontal {
  text-anchor: middle !important; /* center X-axis labels */
}

::v-deep .ct-label.ct-vertical {
  text-anchor: middle !important; /* center Y-axis labels */
}

/* Optional: adjust Y-label position slightly inward for visual balance */
::v-deep .ct-label.ct-vertical {
  dominant-baseline: middle;
  transform: translateX(-5px); /* fine-tune horizontal offset */
}
::v-deep .ct-label.ct-horizontal {
  transform: translateX(-20px);
}
</style>
